import React from "react";
import "./styles.scss";

const PrintText = ({ printable_text, legacy_ticket }) => {
  let parsed;
  if (legacy_ticket) {
    parsed = JSON.parse(legacy_ticket.replace(/[\n\r]/g, "\\n")).TicketText;
  } else if (printable_text) {
    parsed = JSON.parse(printable_text.replace(/[\n\r]/g, "\\n"))._;
  }
  const parts =
    parsed.length > 0 ? parsed.split(/(\+|[0-9] Year: Y+|Boring: Y\b)/gi) : "";
  for (let i = 1; i < parts.length; i += 2) {
    parts[i] = (
      <span className="highlightText" key={i}>
        {parts[i]}
      </span>
    );
  }
  return <div>{parts}</div>;
};

export default PrintText;
